import { computed, ref } from 'vue';

import { defineStore } from 'pinia';

import { useAuthStore } from '@/stores/auth';
import type { Module } from '@/types/module';
import { callApi } from '@/utils/api';
import { handleAxiosError } from '@/utils/error';

export const useModuleStore = defineStore('modules', () => {
    const authStore = useAuthStore();

    const modules = ref<Module[]>([]);
    const areMultipleModulesAccessible = computed(() => modules.value.length > 1);
    const defaultModule = computed(() => modules.value.find((module) => module.name === 'RI&E'));

    async function getAll(): Promise<Module[]> {
        if (modules.value.length > 0) return modules.value;

        try {
            const result = await callApi({
                method: 'GET',
                endpoint: `modules/`
            });

            modules.value = result.object as Module[];
            return modules.value;
        } catch (error) {
            return handleAxiosError(error, [], 'Modules konden niet opgehaald worden');
        }
    }

    async function get(): Promise<Module[]> {
        try {
            const result = await callApi({
                method: 'GET',
                endpoint: `modules/${authStore.currentOrganization?._id}`
            });

            modules.value = result.object as Module[];
            return modules.value;
        } catch (error) {
            return handleAxiosError(error, [], 'Modules konden niet opgehaald worden');
        }
    }

    async function fetchByName(moduleName: string): Promise<Module> {
        try {
            const result = await callApi({
                method: 'GET',
                endpoint: `modules/name/${moduleName}`
            });

            return result.object as Module;
        } catch (error) {
            return handleAxiosError(error, [], 'Module kon niet opgehaald worden');
        }
    }

    return {
        modules,
        areMultipleModulesAccessible,
        defaultModule,
        get,
        getAll,
        fetchByName
    };
});
